module.exports = __webpack_public_path__ + "img/1.95978353.svg";